import { create } from 'zustand';

interface AppRatingStore {
  /**
   * Timestamp of the last render that finished in this tab, or null if none
   * has. The satisfaction survey waits for this moment: a user who has just
   * watched a design appear has an opinion, and a user mid-generation must not
   * be interrupted.
   */
  lastRenderCompletedAt: number | null;

  /**
   * Set once the survey has been offered in this session, so a second finished
   * render does not re-open a dialog the user just closed. Session-scoped only;
   * the durable "do not ask again" state is the server cooldown written by
   * POST /app-rating and /app-rating/snooze.
   */
  offeredThisSession: boolean;

  markRenderCompleted: () => void;
  markOffered: () => void;
}

export const useAppRatingStore = create<AppRatingStore>()((set) => ({
  lastRenderCompletedAt: null,
  offeredThisSession: false,
  markRenderCompleted: () => set({ lastRenderCompletedAt: Date.now() }),
  markOffered: () => set({ offeredThisSession: true }),
}));
